import React from "react";
import img1 from "../../../../Assets/Images/service_gm.png";
import img2 from "../../../../Assets/Images/img-platform-function-02@3x.png";
import img3 from "../../../../Assets/Images/img-platform-function-03@3x.png";
import img4 from "../../../../Assets/Images/img-platform-function-04@3x.png";
import "./styles.scss";

function FREEmain() {
    return (
      <div className="instruction">
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              background: item.backgroundColor,
            }}
            className="instruction-container"
          >
            <div
              style={{ flexDirection: index % 2 !== 0 ? "row-reverse" : "row" }}
              className="instruction-container-item"
            >
              <div className="content">
                <div className="titleFm">{item.title}</div>
                <ul className="detailFm">
                  <li>{item.detail1}</li>
                  <li>{item.detail2}</li>
                </ul>
              </div>
              <div
                style={{
                  justifyContent: index % 2 !== 0 ? "flex-start" : "flex-end",
                }}
                className="img"
              >
                <img src={item.img} alt="" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
  
  export default FREEmain;
  
  const data = [
    {
      title: `擔心客戶管理成本和時間，
      現在BYE~`,
      detail1: "因為我們了解單純諮詢就有很多負擔的",
      detail2: "創業公司、小規模企業的心情！",
      img: img1,
      backgroundColor: "#63aeff",
    },

  ];
  